import { useContext, useMemo } from "react";
import { ReactComponent as PersonalDataIcon } from "../../public/icons/PersonalData.svg";
import { ReactComponent as PasswordEditIcon } from "../../public/icons/profil/PasswordEditIcon.svg";
import { ProfilWidgetItem, RolesEnum, Session } from "../../types";
import { CustomModalContext, LayoutBarContext } from "../../contexts";
import ReactSvgIcon from "../../components/UIElements/ReactSvgIcon";
import EditPasswordForm from "../../components/Profil/Password/EditPasswordForm";
import PersonalData from "../../components/Profil/Default/PersonalData";
import { useLocalStorage } from "../../hooks";
import { sessionStorageKey } from "../../consts";
import { ReactComponent as EstablishmentSelect } from "../../public/icons/profil/EstablishementIcon.svg";
import AccountSwictherModal from "../../components/Profil/AccountSwitcherModal/AccountSwitcherModal";

export function useDefaultProfil() {
    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { updateIsLayoutBarActive, updateContent } =
        useContext(LayoutBarContext);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser },
    } = session;

    const currentUSerHasAdmin = currentUser.groups.find(
        (g) => RolesEnum.ADMIN === g
    );

    const profilWidgetItems: ProfilWidgetItem[] = useMemo(() => {
        const widgets = [
            {
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={PersonalDataIcon}
                    />
                ),
                title: "Mes informations personnelles",
                onClick: () => {
                    updateContent(<PersonalData />);
                    updateIsLayoutBarActive(true);
                },
            },
            {
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={PasswordEditIcon}
                    />
                ),
                title: "Modifier mon mot de passe",
                onClick: () => {
                    updateModal({
                        content: <EditPasswordForm />,
                        title: "Modifier mon mot de passe",
                    });
                    updateIsCustomModalActive(true);
                },
            },
        ];

        if (currentUSerHasAdmin) {
            widgets.push({
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={EstablishmentSelect}
                    />
                ),
                title: "Changer de profil",
                onClick: () => {
                    updateModal({
                        content: <AccountSwictherModal />,
                        title: "",
                    });
                    updateIsCustomModalActive(true);
                    updateIsLayoutBarActive(true);
                },
            });
        }

        return widgets;
    }, []);

    return { profilWidgetItems };
}
